import React from 'react';
import { LoanStatus } from '../LoanStatus';
/**
 * Current loan status view
 * @param states states array represents the loan status
 * @returns loan status view with current status for mobile view
 */
export const CurrentStatus = _ref => {
  let {
    states
  } = _ref;
  const currentState = states.find(ele => ele.status === 'Pending') || states[states.length - 1];
  return /*#__PURE__*/React.createElement(LoanStatus, {
    state: currentState
  });
};
//# sourceMappingURL=index.js.map